import { CurrencyDenomination, MonthYear } from "@common/types";
import { ICommandBase } from "@Quest/cqrs";
import { ValueBalanceType, ValueCommitmentType } from "@Quest/Metrics/types";

export class DeleteMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.DeleteMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string; // StrategyId is treated as a string.
	Id: string; // MetricId is treated as a string.

	constructor(workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.DeleteMetricCommandV1, TCh.Domain.Quest'
	}
}

export class CreateResourceMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateResourceMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;

	Id: string;
	Name: string;
	Description: string | null;
	ResourceId: string;
	ValueBalanceType: ValueBalanceType;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, resourceId: string, valueBalanceType: ValueBalanceType,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.ResourceId = resourceId;
		this.ValueBalanceType = valueBalanceType;
		this.IsScheduleDependent = isScheduleDependent;

		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateResourceMetricCommandV1, TCh.Domain.Quest'
	}
}
export class UpdateResourceMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateResourceMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;

	Id: string;
	Name: string;
	Description: string | null;
	ResourceId: string;
	ValueBalanceType: ValueBalanceType;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, resourceId: string, valueBalanceType: ValueBalanceType,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.ResourceId = resourceId;
		this.ValueBalanceType = valueBalanceType;
		this.IsScheduleDependent = isScheduleDependent;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateResourceMetricCommandV1, TCh.Domain.Quest'
	}
}

export class CreateRevenueMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateRevenueMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;

	Id: string;
	Name: string;
	Description: string | null;
	Denomination: CurrencyDenomination; 
	RevenueId: string | null;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination, revenueId: string | null,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.Denomination = denomination;
		this.RevenueId = revenueId;
		this.IsScheduleDependent = isScheduleDependent;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateRevenueMetricCommandV1, TCh.Domain.Quest'
	}
}
export class UpdateRevenueMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateRevenueMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;

	Id: string;
	Name: string;
	Description: string | null;
	Denomination: CurrencyDenomination;
	RevenueId: string | null;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination, revenueId: string | null,
		isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.Denomination = denomination;
		this.RevenueId = revenueId;
		this.IsScheduleDependent = isScheduleDependent;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateRevenueMetricCommandV1, TCh.Domain.Quest'
	}
}

export class CreateTotalCostMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateTotalCostMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string; 
	Id: string;
	Name: string;
	Description: string | null;
	Denomination: CurrencyDenomination;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination,
		defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.Denomination = denomination;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateTotalCostMetricCommandV1, TCh.Domain.Quest'
	}
}
export class UpdateTotalCostMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateTotalCostMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string | null;
	Denomination: CurrencyDenomination;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination,
		defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null, valueCommitmentType: ValueCommitmentType, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.Denomination = denomination;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateTotalCostMetricCommandV1, TCh.Domain.Quest'
	}
}

export class CreateCapexMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateCapexMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;

	Id: string;
	Name: string;
	Description: string | null;
	Denomination: CurrencyDenomination;
	AccountId: string | null;
	IsDepreciation: boolean;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;

	constructor(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination, accountId: string | null,
		isDepreciation: boolean, isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.Denomination = denomination;
		this.AccountId = accountId;
		this.IsDepreciation = isDepreciation;
		this.IsScheduleDependent = isScheduleDependent;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateCapexMetricCommandV1, TCh.Domain.Quest'
	}
}
export class UpdateCapexMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateCapexMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;

	Id: string;
	Name: string;
	Description: string | null;
	Denomination: CurrencyDenomination;
	AccountId: string | null;
	IsDepreciation: boolean;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;

	constructor(workspaceId: number, strategyId: string, id: string, name: string, description: string | null, denomination: CurrencyDenomination, accountId: string | null,
		isDepreciation: boolean, isScheduleDependent: boolean, defaultProjectStartDate: MonthYear | null, startDateBoundary: MonthYear | null, endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.Denomination = denomination;
		this.AccountId = accountId;
		this.IsDepreciation = isDepreciation;
		this.IsScheduleDependent = isScheduleDependent;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateCapexMetricCommandV1, TCh.Domain.Quest'
	}
}

export class CreateExpenseMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateExpenseMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string | null;
	ExpenseAccountId: string | null;
	ValueBalanceType: ValueBalanceType;
	Denomination: CurrencyDenomination;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(
		workspaceId: number,
		strategyId: string,
		id: string,
		name: string,
		description: string | null,
		expenseAccountId: string | null,
		valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination,
		isScheduleDependent: boolean,
		defaultProjectStartDate: MonthYear | null,
		startDateBoundary: MonthYear | null,
		endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean
	)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.ExpenseAccountId = expenseAccountId;
		this.ValueBalanceType = valueBalanceType;
		this.Denomination = denomination;
		this.IsScheduleDependent = isScheduleDependent;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase): boolean
	{
		return cmd.$type === 'TCh.Domain.Quest.Metrics.Commands.CreateExpenseMetricCommandV1, TCh.Domain.Quest';
	}
}
export class UpdateExpenseMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateExpenseMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string | null;
	ExpenseAccountId: string | null;
	Denomination: CurrencyDenomination;
	ValueBalanceType: ValueBalanceType;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(
		workspaceId: number,
		strategyId: string,
		id: string,
		name: string,
		description: string | null,
		expenseAccountId: string | null,
		valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination,
		isScheduleDependent: boolean,
		defaultProjectStartDate: MonthYear | null,
		startDateBoundary: MonthYear | null,
		endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean
	)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.ExpenseAccountId = expenseAccountId;
		this.Denomination = denomination;
		this.ValueBalanceType = valueBalanceType;
		this.IsScheduleDependent = isScheduleDependent;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase): boolean
	{
		return cmd.$type === 'TCh.Domain.Quest.Metrics.Commands.UpdateExpenseMetricCommandV1, TCh.Domain.Quest';
	}
}

export class CreateMarginCogsMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateMarginCogsMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string | null;
	RevenueId: string | null;
	Denomination: CurrencyDenomination;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(
		workspaceId: number,
		strategyId: string,
		id: string,
		name: string,
		description: string | null,
		revenueId: string | null,
		denomination: CurrencyDenomination,
		isScheduleDependent: boolean,
		defaultProjectStartDate: MonthYear | null,
		startDateBoundary: MonthYear | null,
		endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean
	)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.RevenueId = revenueId;
		this.Denomination = denomination;
		this.IsScheduleDependent = isScheduleDependent;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase): boolean
	{
		return cmd.$type === 'TCh.Domain.Quest.Metrics.Commands.CreateMarginCogsMetricCommandV1, TCh.Domain.Quest';
	}
}
export class UpdateMarginCogsMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateMarginCogsMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string | null;
	RevenueId: string | null;
	Denomination: CurrencyDenomination;
	IsScheduleDependent: boolean;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(
		workspaceId: number,
		strategyId: string,
		id: string,
		name: string,
		description: string | null,
		revenueId: string | null,
		denomination: CurrencyDenomination,
		isScheduleDependent: boolean,
		defaultProjectStartDate: MonthYear | null,
		startDateBoundary: MonthYear | null,
		endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean
	)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.RevenueId = revenueId;
		this.Denomination = denomination;
		this.IsScheduleDependent = isScheduleDependent;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase): boolean
	{
		return cmd.$type === 'TCh.Domain.Quest.Metrics.Commands.UpdateMarginCogsMetricCommandV1, TCh.Domain.Quest';
	}
}

export class CreateResourceCostMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateResourceCostMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string | null;
	ResourceId: string | null;
	ValueBalanceType: ValueBalanceType;
	Denomination: CurrencyDenomination;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(
		workspaceId: number,
		strategyId: string,
		id: string,
		name: string,
		description: string | null,
		resourceId: string | null,
		valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination,
		defaultProjectStartDate: MonthYear | null,
		startDateBoundary: MonthYear | null,
		endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean
	)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.ResourceId = resourceId;
		this.ValueBalanceType = valueBalanceType;
		this.Denomination = denomination;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase): boolean
	{
		return cmd.$type === 'TCh.Domain.Quest.Metrics.Commands.CreateResourceCostMetricCommandV1, TCh.Domain.Quest';
	}
}
export class UpdateResourceCostMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateResourceCostMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string | null;
	ResourceId: string | null;
	ValueBalanceType: ValueBalanceType;
	Denomination: CurrencyDenomination;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(
		workspaceId: number,
		strategyId: string,
		id: string,
		name: string,
		description: string | null,
		resourceId: string | null,
		valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination,
		defaultProjectStartDate: MonthYear | null,
		startDateBoundary: MonthYear | null,
		endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean
	)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.ResourceId = resourceId;
		this.ValueBalanceType = valueBalanceType;
		this.Denomination = denomination;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase): boolean
	{
		return cmd.$type === 'TCh.Domain.Quest.Metrics.Commands.UpdateResourceCostMetricCommandV1, TCh.Domain.Quest';
	}
}


export class CreateCostSubtotalMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateCostSubtotalMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string | null;
	SubtotalId: string;
	ValueBalanceType: ValueBalanceType;
	Denomination: CurrencyDenomination;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(
		workspaceId: number,
		strategyId: string,
		id: string,
		name: string,
		description: string | null,
		subtotalId: string,
		valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination,
		defaultProjectStartDate: MonthYear | null,
		startDateBoundary: MonthYear | null,
		endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean
	)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.SubtotalId = subtotalId;
		this.ValueBalanceType = valueBalanceType;
		this.Denomination = denomination;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase): boolean
	{
		return cmd.$type === 'TCh.Domain.Quest.Metrics.Commands.CreateCostSubtotalMetricCommandV1, TCh.Domain.Quest';
	}
}
export class UpdateCostSubtotalMetricCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateCostSubtotalMetricCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string | null;
	SubtotalId: string;
	ValueBalanceType: ValueBalanceType;
	Denomination: CurrencyDenomination;
	DefaultProjectStartDate: MonthYear | null;
	StartDateBoundary: MonthYear | null;
	EndDateBoundary: MonthYear | null;
	ValueCommitmentType: ValueCommitmentType;
	ApplyBenefitsConfidenceFactor: boolean;

	constructor(
		workspaceId: number,
		strategyId: string,
		id: string,
		name: string,
		description: string | null,
		subtotalId: string,
		valueBalanceType: ValueBalanceType,
		denomination: CurrencyDenomination,
		defaultProjectStartDate: MonthYear | null,
		startDateBoundary: MonthYear | null,
		endDateBoundary: MonthYear | null,
		valueCommitmentType: ValueCommitmentType,
		applyBenefitsConfidenceFactor: boolean
	)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.SubtotalId = subtotalId;
		this.ValueBalanceType = valueBalanceType;
		this.Denomination = denomination;
		this.DefaultProjectStartDate = defaultProjectStartDate;
		this.StartDateBoundary = startDateBoundary;
		this.EndDateBoundary = endDateBoundary;
		this.ValueCommitmentType = valueCommitmentType;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase): boolean
	{
		return cmd.$type === 'TCh.Domain.Quest.Metrics.Commands.UpdateCostSubtotalMetricCommandV1, TCh.Domain.Quest';
	}
}
